module.exports = __webpack_public_path__ + "img/studyFour.3a042ec5.png";